import React, { Component } from 'react'
import { database } from '../../firebase'
import { ref, child, query, orderByChild, startAt, endAt, limitToFirst, get } from 'firebase/database'
import { ControlSearch } from '../forms/Controls'
import './Partidos.css'

class Partidos extends Component {
  constructor (props) {
    super(props)
    this.state = {
      local: '',
      localId: '',
      localList: [],
      visitante: '',
      visitanteId: '',
      visitanteList: []
    }
    this.handleLocal = this.handleLocal.bind(this)
    this.handleVisitante = this.handleVisitante.bind(this)
    this.handleLocalClick = this.handleLocalClick.bind(this)
    this.handleVisitanteClick = this.handleVisitanteClick.bind(this)
    this.dbRef = ref(database, 'equipos')
  }
  handleLocal (ev) {
    const value = ev.target.value.replace(/\b\w/g, l => l.toUpperCase())
    this.setState({
      local: value,
      localId: ''
    })
    this.props.handleLocal('', '', this.props.n)
    if (value) {
      this.query(value)
      .then((query) => {
        const items = []
        query.forEach((item) => {
          items.push({
            id: item.key,
            nombre: item.val().nombre
          })
        })
        this.setState({
          localList: items
        })
      })
      .catch((err) => {
        console.log(err)
      })
    } else {
      this.setState({
        localList: []
      })
    }
  }
  handleVisitante (ev) {
    const value = ev.target.value.replace(/\b\w/g, l => l.toUpperCase())
    this.setState({
      visitante: value,
      visitanteId: ''
    })
    this.props.handleVisitante('', '', this.props.n)
    if (value) {
      this.query(value)
      .then((query) => {
        const items = []
        query.forEach((item) => {
          items.push({
            id: item.key,
            nombre: item.val().nombre
          })
        })
        this.setState({
          visitanteList: items
        })
      })
      .catch((err) => {
        console.log(err)
      })
    } else {
      this.setState({
        visitanteList: []
      })
    }
  }
  handleLocalClick (nombre, id) {
    this.setState({
      local: nombre,
      localId: id,
      localList: []
    })
    this.props.handleLocal(nombre, id, this.props.n)
  }
  handleVisitanteClick (nombre, id) {
    this.setState({
      visitante: nombre,
      visitanteId: id,
      visitanteList: []
    })
    this.props.handleVisitante(nombre, id, this.props.n)
  }
  query (value) {
    return new Promise((resolve, reject) => {
      const indexRef = child(this.dbRef, 'index')
      const equiposQuery = query(
        indexRef,
        orderByChild('nombre'),
        startAt(value),
        endAt(value + '\uf8ff'),
        limitToFirst(10)
      )
      get(equiposQuery)
      .then((snap) => {
        resolve(snap)
      })
      .catch((err) => {
        reject(err)
      })
    })
  }
  render () {
    return (
      <div className='partidos'>
        <div className={this.props.error ? 'row error' : 'row'}>
          <div className='col-sm-2'>
            <label>Local</label>
          </div>
          <div className='col-sm-4'>
            <ControlSearch
              placeholder='Nombre de equipo'
              value={this.state.local}
              onChange={this.handleLocal}
              result={this.state.localId !== ''}
              list={this.state.localList}
              onClick={this.handleLocalClick}
              error={this.props.error}
            />
          </div>
          <div className='col-sm-2'>
            <label>Visitante</label>
          </div>
          <div className='col-sm-4'>
            <ControlSearch
              placeholder='Nombre de equipo'
              value={this.state.visitante}
              onChange={this.handleVisitante}
              result={this.state.visitanteId !== ''}
              list={this.state.visitanteList}
              onClick={this.handleVisitanteClick}
              error={this.props.error}
            />
          </div>
        </div>
        <div className='partidos__footer'>
          <p>{this.props.n + 1}</p>
          {this.props.n === 0 ? null : <a href='#delete' onClick={(ev) => this.props.handleDelete(ev, this.props.id)}>Eliminar</a>}
        </div>
      </div>
    )
  }
}

export default Partidos
